import { theme } from './';

export default `
  html {
    box-sizing: border-box;
    font-size:${theme.htmlFontSize}px !important;
  }
  #root {
    color: ${theme.colors.neutralGrey8};
    font-family: ${theme.fontFamily};
    font-size: ${theme.fontSizes.m};
    margin: 0;
    line-height: 1.33;
    padding: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    .ui, h1, h2, h3, h4, h5, h6 {
      font-family: ${theme.fontFamily};
    }
  }

  #root {
    min-height: 100%;
    height: 1px;
    display: flex;
    flex-direction: column;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  strong {
    font-weight: ${theme.fontWeights.bold};
  }

  @page {
    size: A4;
    margin: 0;
  }

  @media print {
    html, body {
      width: 210mm;
      height: auto !important;
    }

    .ui.container {
      width: 700px;
      margin-right: auto !important;
      margin-left: auto !important;
    }

    #root {
      display: block !important;
      height: auto !important;
    }

    body.with-print *:not(.printable) {
      visibility: hidden;
    }
    .printable * {
      visibility: visible !important;
    }
  }
  
  /* Supwiz Chat Button Tooltip */

  [aria-label="Restore chat"],
  [aria-label="Minimize chat"] {
    position: relative;
  }

  [aria-label="Restore chat"]::after,
  [aria-label="Minimize chat"]::after {
    content: "Chat with us";
    position: fixed;
    bottom: 88px;
    right: 72px;

    background: #2b2b2b;
    color: #ffffff;
    font-size: 12px;
    padding: 6px 10px;
    border-radius: 6px;
    white-space: nowrap;

    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s ease;
    z-index: 2147483647;
  }

  [aria-label="Restore chat"]:hover::after,
  [aria-label="Minimize chat"]:hover::after {
    opacity: 1;
  }

  /* Disable tooltip on touch devices */
  @media (hover: none) {
    [aria-label="Restore chat"]::after,
    [aria-label="Minimize chat"]::after {
      display: none;
    }
  }
`;
